/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import {
  Grid,
  Tab,
  Tabs,
  Icon,
  FormControlLabel,
  Checkbox,
  FormControl,
  RadioGroup,
  Radio,
  Toolbar,
  Paper,
  Typography,
} from "@mui/material";
// import MUIRichTextEditor from "mui-rte";
// import { createTheme, MuiThemeProvider } from '@mui/material/styles';
import Input from "../../../component/inputpm";
import Button from "../../../component/button";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import EditIcon from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import { Divider, Tooltip } from "@mui/material";
import classes from "../packagedSolution/createPackage.module.css";
// import TextEditor from "../../../component/richTextEditor";
import TiptapEditor from "../../../component/richTextEditor/TiptapEditor";
import {
  EditorState,
  ContentState,
  convertToRaw,
  convertFromRaw,
  Modifier,
} from "draft-js";

const AdditionalInfo = (props) => {
  const [overview, setOverview] = useState(
    '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
  );
  // const [overviewState, setOverviewState] = useState(EditorState.createEmpty());

  const [techSpecs, setTechSpecs] = useState(
    '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
  );
  // const [techSpecsState, setTechSpecsState] = useState(
  //   EditorState.createEmpty(),
  // );

  const [whatsIncluded, setWhatsIncluded] = useState(
    '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
  );
  // const [whatsIncludedState, setWhatsIncludedState] = useState(
  //   EditorState.createEmpty(),
  // );

  useEffect(() => {
    if (props.data.basicDetail.productOverview) {
      // setOverviewState(
      //   EditorState.createWithContent(
      //     convertFromRaw(JSON.parse(props.data.basicDetail.productOverview)),
      //   ),
      // );
      setOverview(props.data.basicDetail.productOverview);
    } else {
      // setOverviewState(EditorState.createEmpty());
      // setOverview(
      //   '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
      // );
    }

    if (props.data.basicDetail.productWhatsIncluded) {
      // setWhatsIncludedState(
      //   EditorState.createWithContent(
      //     convertFromRaw(
      //       JSON.parse(props.data.basicDetail.productWhatsIncluded),
      //     ),
      //   ),
      // );
      setWhatsIncluded(props.data.basicDetail.productWhatsIncluded);
    } else {
      // setWhatsIncludedState(EditorState.createEmpty());
      // setWhatsIncluded(
      //   '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
      // );
    }

    if (props.data.basicDetail.productTechSpecs) {
      // setTechSpecsState(
      //   EditorState.createWithContent(
      //     convertFromRaw(JSON.parse(props.data.basicDetail.productTechSpecs)),
      //   ),
      // );
      setTechSpecs(props.data.basicDetail.productTechSpecs);
    } else {
      // setTechSpecsState(EditorState.createEmpty());
      setTechSpecs(
        '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
      );
    }
  }, []);
  const t = props.t;
  const editorRef = useRef(null);
  const [tabValue, setTabValue] = useState(0);
  const [publishTab, setPublishTabValue] = useState(0);

  const changeTab = (event, newValue) => {
    props.handleEditor();
    setTabValue(newValue);
  };
  const publishTabChange = (event, newValue) => {
    setPublishTabValue(newValue);
  };
  // const handleEditor = () => {
  //     if (editorRef.current) {
  //         editorRef.current.save();
  //     }
  // }
  // const defaultTheme = createTheme();
  // Object.assign(defaultTheme, {
  //     overrides: {
  //         MUIRichTextEditor: {
  //             editor: {
  //                 borderBottom: "1px solid gray",
  //                 borderTop: "1px solid gray"
  //             }
  //         }
  //     }
  // })

  const onChangeOverview = (state) => {
    // setOverviewState(state);
    // setOverview(JSON.stringify(convertToRaw(state.getCurrentContent())));
    // props.save(
    //   JSON.stringify(convertToRaw(state.getCurrentContent())),
    //   "productOverview",
    // );
    setOverview(state);
    props.save(
      state,
      "productOverview",
    );
  };

  const onChangeTechSpecs = (state) => {
    // setTechSpecsState(state);
    // setTechSpecs(JSON.stringify(convertToRaw(state.getCurrentContent())));
    // props.save(
    //   JSON.stringify(convertToRaw(state.getCurrentContent())),
    //   "productTechSpecs",
    // );
    setTechSpecs(state);
    props.save(
      state,
      "productTechSpecs",
    );
  };

  const onChangeWhatsIncluded = (state) => {
    // setWhatsIncludedState(state);
    // setWhatsIncluded(JSON.stringify(convertToRaw(state.getCurrentContent())));
    // props.save(
    //   JSON.stringify(convertToRaw(state.getCurrentContent())),
    //   "productWhatsIncluded",
    // );
    setWhatsIncluded(state);
    props.save(
      state,
      "productWhatsIncluded",
    );
  };
  return (
    <div style={{ minHeight: 250 }}>
      <React.Fragment>
        <Grid container>
          <Grid
            item
            size={{
              xs: 12,
            }}
          >
            <Tabs
              indicatorColor="primary"
              onChange={changeTab}
              // textColor="primary"
              value={tabValue}
              variant="scrollable"
              style={{ justifyContent: "center" }}
              className={["normalizeTabText", classes.createPackageTabs].join(
                " ",
              )}
            >
              <Tab label={t("OVERVIEW")} />
              <Tab label={t("TECH_SPECS")} />
              <Tab label={t("WHAT_IS_INCLUDED")} />
              {/* <Tab label={t('ADDITIONAL_IMAGES')} /> */}
              {/* <Tab label={t('PUBLISH')} /> */}
            </Tabs>
          </Grid>
          {tabValue === 0 && (
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <TiptapEditor
                value={overview}
                onChange={onChangeOverview}
                placeholder={t("ENTER_PRODUCT_OVERVIEW_CONTENT_HERE")}
                readOnly={props.readonly ? true : false}
              />
            </Grid>
          )}
          {tabValue === 1 && (
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <TiptapEditor
                value={techSpecs}
                onChange={onChangeTechSpecs}
                placeholder={t("ENTER_PRODUCT_TECHNICAL_SPECIFICAIONS_HERE")}
                readOnly={props.readonly ? true : false}
              />
            </Grid>
          )}
          {tabValue === 2 && (
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <TiptapEditor
                value={whatsIncluded}
                onChange={onChangeWhatsIncluded}
                placeholder={t("ENTER_WHAT_IS_INCLUDED_TEXT_HERE")}
                readOnly={props.readonly ? true : false}
              />
            </Grid>
          )}

          {/* {tabValue === 3 &&
                        <>
                            <Grid item xs={12} style={{ marginBottom: 15, marginTop: 10 }}>
                                <Input
                                    name={'productAdditionalImage1'}
                                    onChange={event => props.onImageChange(event, "productAdditionalImage1Src")}
                                    inputProps={{ type: "file", id: "productAdditionalImage1" }}
                                    // placeholder={'Image'}
                                    className="custom-file-input"
                                    source={props.data.basicDetail.productAdditionalImage1Src}
                                />
                                <label htmlFor="productAdditionalImage1" className="input-file-label">
                                    <Icon>attach_file</Icon>
                                    <label>
                                        {props.data.basicDetail.productAdditionalImage1 ? props.data.basicDetail.productAdditionalImage1 : <span className="input-file-placeholder">{t('PRODUCT_IMAGE')}</span>}
                                    </label>
                                </label>
                            </Grid>
                            <Grid item xs={12} style={{ marginBottom: 15 }}>
                                <Input
                                    name={'productAdditionalImage2'}
                                    onChange={event => props.onImageChange(event, "productAdditionalImage2Src")}
                                    inputProps={{ type: "file", id: "productAdditionalImage2" }}
                                    // placeholder={'Image'}
                                    className="custom-file-input"
                                    source={props.data.basicDetail.productAdditionalImage2Src}
                                />
                                <label htmlFor="productAdditionalImage2" className="input-file-label">
                                    <Icon>attach_file</Icon>
                                    <label>
                                        {props.data.basicDetail.productAdditionalImage2 ? props.data.basicDetail.productAdditionalImage2 : <span className="input-file-placeholder">{t('PRODUCT_IMAGE')}</span>}
                                    </label>
                                </label>
                            </Grid>
                            <Grid item xs={12} style={{ marginBottom: 15 }}>
                                <Input
                                    name={'productAdditionalImage3'}
                                    onChange={event => props.onImageChange(event, "productAdditionalImage3Src")}
                                    inputProps={{ type: "file", id: "productAdditionalImage3" }}
                                    // placeholder={'Image'}
                                    className="custom-file-input"
                                    source={props.data.basicDetail.productAdditionalImage3Src}
                                />
                                <label htmlFor="productAdditionalImage3" className="input-file-label">
                                    <Icon>attach_file</Icon>
                                    <label>
                                        {props.data.basicDetail.productAdditionalImage3 ? props.data.basicDetail.productAdditionalImage3 : <span className="input-file-placeholder">{t('PRODUCT_IMAGE')}</span>}
                                    </label>
                                </label>
                            </Grid>
                            <Grid item xs={12}>
                                <Input
                                    name={'productAdditionalImage4'}
                                    onChange={event => props.onImageChange(event, "productAdditionalImage4Src")}
                                    inputProps={{ type: "file", id: "productAdditionalImage4" }}
                                    // placeholder={'Image'}
                                    className="custom-file-input"
                                    source={props.data.basicDetail.productAdditionalImage4Src}
                                />
                                <label htmlFor="productAdditionalImage4" className="input-file-label">
                                    <Icon>attach_file</Icon>
                                    <label>
                                        {props.data.basicDetail.productAdditionalImage4 ? props.data.basicDetail.productAdditionalImage4 : <span className="input-file-placeholder">{t('PRODUCT_IMAGE')}</span>}
                                    </label>
                                </label>
                            </Grid>
                        </>
                    } */}
          {/* {tabValue === 3 &&
                        <Grid item xs={12}>
                            <Tabs
                                indicatorColor="primary"
                                onChange={publishTabChange}
                                textColor="primary"
                                value={publishTab}
                                variant="scrollable"
                                className={['normalizeTabText', classes.createPackageTabs].join(' ')}
                            >
                                <Tab label={t('CONFIGURATIONS')} />
                                <Tab label={t('T&C')} />
                            </Tabs>

                            {publishTab === 0 &&
                                <Grid container spacing={2} justifyContent="center" direction='row' style={{
                                    maxWidth: 'inherit', alignContent: 'baseline',
                                    alignItems: 'center', marginTop: '12px'
                                }}>
                                    
                                    <Grid item xs={4} style={{ marginLeft: '0px' }}>
                                        <FormControlLabel
                                            checked={props.orderApproval}
                                            control={<Checkbox color="primary" />}
                                            label={t('REQUIRE_ORDER_APPROVAL')}
                                            labelPlacement="end"
                                            className={classes.requireApproval}
                                            onChange={props.updateTrigger}
                                            name="orderApproval"
                                        /> */}
          {/* <FormControlLabel
                                            checked={props.data.basicDetail.orderApproval}
                                            control={<Checkbox color="primary" />}
                                            labelPlacement="start"
                                            // className={classes.requireApproval}
                                            onChange={props.onChange}
                                            name="orderApproval"
                                            style={{ marginLeft: 0 }}
                                        /> */}
          {/* </Grid>
                                    <Divider orientation="vertical" flexItem></Divider>
                                    <Grid item xs={6} style={{ marginLeft: '54px' }}>
                                        <Grid item xs={12}>
                                            {t('BILLING_TRIGGER')}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.billingTriggerPhase}> */}
          {/* <FormLabel component="legend">Gender</FormLabel> */}
          {/* <RadioGroup defaultValue="DEFAULT" value={props.billingTriggerPhase} aria-label="activationTrigger" name="billingTriggerPhase" row onChange={props.updateTrigger} style={{ paddingLeft: '8px' }}>
                                                    <FormControlLabel value="DEFAULT" control={<Radio color="primary" />} label={t('DEFAULT')} labelPlacement="right" style={{ paddingRight: '14px' }} />
                                                    <FormControlLabel value="ACTIVATION" control={<Radio color="primary" />} label={t('ACTIVATION')} labelPlacement="right" style={{ paddingRight: '14px' }} />
                                                    <FormControlLabel value="PROVISIONING" control={<Radio color="primary" />} label={t('PROVISIONING')} labelPlacement="right" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            }
                            {publishTab === 1 &&
                                <Grid container spacing={2} justifyContent="space-evenly" style={{
                                    alignItems: 'center', marginTop: '12px', justifyContent: 'flex-start'
                                }}>
                                    <Grid item xs={6}>
                                        <Input
                                            name={'termsText'}
                                            value={props.termsData.termsText}
                                            variant={'outlined'}
                                            onChange={event => props.onChangeTerms(event)}
                                            placeholder={t('TERM_&_CONDITIONS_TEXT') + ' *'}
                                            size={'small'}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Input
                                            name={'termsUrl'}
                                            value={props.termsData.termsUrl}
                                            onChange={event => props.onChangeTerms(event)}
                                            placeholder={t('TERM_&_CONDITIONS_URL') + ' *'}
                                            variant={'outlined'}
                                            size={'small'}
                                        />
                                    </Grid> */}

          {/* <Grid item xs={12}>
                                        <MuiThemeProvider theme={defaultTheme}>
                                            <MUIRichTextEditor
                                                label={t('TERM_&_CONDITIONS_TEXT') + ' *'}
                                                name={'termsText'}
                                                // onSave={event => props.save(event, "productT&C")}
                                                // onChange={event => props.onChangeTerms(event)}
                                                ref={editorRef}
                                                inlineToolbar={true}
                                                value={props.termsData.termsText}
                                            />
                                        </MuiThemeProvider>
                                    </Grid> */}

          {/* <Grid item xs={12} align={'right'}>
                                        {props.termCondToEdit !== null ?
                                            <>
                                                <Button onClick={() => props.cancelUpdateTermsCond()} > {t('CANCEL')} </Button>
                                                <Button onClick={() => props.updateTermsCond()} style={{ marginLeft: '8px' }}> {t('UPDATE_T&C')} </Button>
                                            </>
                                            :
                                            <Button onClick={() => props.addTermsCond()}> {t('ADD_T&C')} </Button>
                                        }
                                    </Grid>
                                    {(props.data.basicDetail.terms && props.data.basicDetail.terms.length > 0) &&
                                        <Grid container spacing={2} justifyContent="space-evenly" style={{
                                            alignItems: 'center', marginTop: '12px', marginLeft: '0px'
                                        }}>
                                            <Grid item xs={12}>
                                                <Typography variant="h6" id="tableTitle">
                                                    {t('TERM_&_CONDITIONS')}
                                                </Typography>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>{t('TERM_&_CONDITIONS_TEXT')}</TableCell>
                                                            <TableCell>{t('TERM_&_CONDITIONS_URL')}</TableCell>
                                                            <TableCell align="left"></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {props.data.basicDetail.terms && props.data.basicDetail.terms.map((row, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell component="th" scope="row">{row.termsText}</TableCell>
                                                                <TableCell>{row.termsUrl}</TableCell>
                                                                <TableCell align="center" style={{ 'width': '55px' }}>
                                                                    <Tooltip title={t('DELETE')} style={{ 'marginRight': '5px' }}>
                                                                        <Delete onClick={() => { props.removeTermAndCond(index) }} />
                                                                    </Tooltip>
                                                                    <Tooltip title={t('EDIT')}>
                                                                        <EditIcon onClick={() => { props.editTermAndCond(row, index) }}></EditIcon>
                                                                    </Tooltip>
                                                                </TableCell>

                                                            </TableRow>
                                                        ))} */}

          {/* {(!props.data.basicDetail.terms || props.data.basicDetail.terms.length === 0) &&
                                                        <TableRow>
                                                            <TableCell component="th" scope="row" colSpan={3} align="center">
                                                                {t('NO_TERM_&_CONDITIONS_AVAILABLE')}
                                                            </TableCell>
                                                        </TableRow>
                                                    } */}
          {/* </TableBody>
                                                </Table>
                                            </Grid>
                                        </Grid>
                                    }
                                </Grid>
                            }
                        </Grid> */}
          {/* } */}
        </Grid>
      </React.Fragment>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};
export default connect(mapStateToProps)(
  withTranslation("translations")(AdditionalInfo),
);
